import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Customer = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="customer icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M12 0C9.23857 0 6.99999 2.23858 6.99999 5V7C6.99999 9.76142 9.23857 12 12 12C14.7614 12 17 9.76142 17 7V5C17 2.23858 14.7614 0 12 0Z"
    />
    <path
      className={pathClass}
      d="M12 13C16.6967 13 20.7059 15.9436 22.2835 20.0865C23.0696 22.151 21.2091 24 19 24H4.99999C2.79085 24 0.930387 22.151 1.71652 20.0865C3.29406 15.9436 7.30328 13 12 13Z"
    />
  </svg>
)
